var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(tag){return _c('el-tag',{key:tag.id,staticClass:"tag",attrs:{"type":_vm.colors[tag.id % _vm.colors.length]}},[_c('i',{staticClass:"el-icon-collection-tag tag-item"}),_vm._v(_vm._s(tag.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }